import React, { useEffect, useState } from "react";
import {
  SearchSelectors,
  UserContextSelectors
} from "../../../redux/selectors";
import { EmptyComponent } from "../../common/EmptyComponent";
import Loadable from "react-loadable";
import { ClientProviderEnum } from "../../../constants";
import { useSelector } from "react-redux";
import { useFeature } from "../../../hooks/useFeature";
import { AppFeatures } from "../../../constants/featureFlags";
import { PageContextUtils } from "../../../utils";

const getSearchMobile = clientProvider => {
  return Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "search/[request]" */ `./${clientProvider}/SearchMobileMenuSection`
      ),

    loading: EmptyComponent
  });
};

const importSearchCss = clientProvider => {
  import(
    /* webpackChunkName: "search/[request]" */ `./${clientProvider}/css/${
      clientProvider === ClientProviderEnum.Kambi
        ? "search.scss"
        : `search-mobile-menu.scss`
    }`
  );
};

const SearchMenuSection = () => {
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const searchSettings = useSelector(SearchSelectors.settings);
  const [isSearchEnabled, setIsSearchEnabled] = useState(false);
  const { name } = PageContextUtils.getClientProviderData();
  const isInKambiSearchFeature = useFeature(AppFeatures.KAMBI_SEARCH);

  useEffect(() => {
    const _isSearchEnabled =
      name === ClientProviderEnum.Spectate
        ? searchSettings.enabled
        : isInKambiSearchFeature;

    setIsSearchEnabled(_isSearchEnabled);
  }, [name, searchSettings.enabled, isInKambiSearchFeature]);

  let SearchMenuSection;
  if (!isMobile || !isSearchEnabled) {
    SearchMenuSection = null;
  } else if (isSearchEnabled) {
    importSearchCss(name);
    SearchMenuSection = getSearchMobile(name);
  }

  return <>{SearchMenuSection && <SearchMenuSection />}</>;
};

export default React.memo(SearchMenuSection);
